const topics = [
  { label: '暑期档新片', heat: '98.6万热度', tag: 'hot' },
  { label: '悬疑烧脑剧', heat: '87.3万热度', tag: 'trending' },
  { label: '高分经典', heat: '76.1万热度', tag: '' },
  { label: '国产动画', heat: '65.8万热度', tag: 'new' },
  { label: '韩剧热播', heat: '59.2万热度', tag: 'trending' },
  { label: '纪录片精选', heat: '48.5万热度', tag: '' },
  { label: '喜剧合家欢', heat: '42.7万热度', tag: '' },
  { label: '动作大片', heat: '39.3万热度', tag: 'hot' },
  { label: '古装仙侠', heat: '35.6万热度', tag: 'new' },
  { label: '科幻巨制', heat: '31.4万热度', tag: '' },
];

const tagStyles: Record<string, string> = {
  hot: 'bg-accent-500/15 text-accent-400 border-accent-500/20',
  trending: 'bg-primary-500/15 text-primary-400 border-primary-500/20',
  new: 'bg-green-500/15 text-green-400 border-green-500/20',
};

const tagLabels: Record<string, string> = {
  hot: '热',
  trending: '爆',
  new: '新',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            热门话题
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            全网影迷正在热议的影视话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="flex items-center gap-3 px-5 py-3 bg-background-100 border border-background-300/30 rounded-full hover:border-primary-500/30 hover:bg-background-200/50 transition-all duration-200 cursor-pointer group"
            >
              {topic.tag && tagStyles[topic.tag] && (
                <span className={`inline-block px-2 py-0.5 text-[11px] font-bold rounded-full border ${tagStyles[topic.tag]}`}>
                  {tagLabels[topic.tag]}
                </span>
              )}
              <span className="text-sm font-medium text-foreground-200 group-hover:text-foreground-100 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}